var card_default = {
  "link": "_6CITc",
  "container": "r7TYh",
  "cardLayout": "_54LQ6",
  "imageEnd": "Xyerz",
  "imageStart": "y54to",
  "imageTop": "M9gaS",
  "right": "Yd1-m",
  "ltr": "FLErF",
  "rtl": "-QAuO",
  "imageContainer": "QHe9W",
  "image": "TyfhS",
  "responsiveImage": "w-L9R",
  "squareImage": "_9W2iY",
  "rectangleImage": "X-Dsn",
  "squareRatio": "BBUu7",
  "rectangleRatio": "HIT2E",
  "imageFill": "_2g444",
  "imageFit": "biXkx",
  "imageRibbon": "s8A4q"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
